import * as React from 'react';
import { QuoteType } from '../../../SE.interfaces';

/**
 * Shared across the Quote Selection task (SMT71). Each per-vendor RFQ_QUOTE panel reports its selected
 * quote here so the task-level wrapper can render one combined footer (Total Quote Amount / Deviation)
 * outside the tabs.
 */
export interface SEQuoteSelectionContextValue {
  /**
   * A tab reports its current pick. Most vendor types report a single QuoteType (or undefined when
   * cleared); Shipping Line (SMF430) reports an ARRAY — one pick per container size — so the task-level
   * footer flattens before totalling. See SEShippingLineSizeTabs.
   */
  reportSelection: (fieldKey: string, quote: QuoteType | QuoteType[] | undefined) => void;
}

export const SEQuoteSelectionContext = React.createContext<SEQuoteSelectionContextValue>({
  reportSelection: () => undefined,
});

/**
 * Quote Candidates channel for the Quote Selection task (SMT71) and its approval (SMT72), provided by
 * the task modal (an ancestor of the panels) so it tunnels through SEFieldGroup / SEQuoteTaskTabs
 * without prop drilling.
 *  - `reportCandidates` (SMT71): each per-vendor panel reports its full fetched quote list so the
 *    modal can snapshot them all into the Quote Candidates field (SMF427) on submit.
 *  - `savedCandidates` (SMT72): the frozen SMF427 snapshot the ops user saw; the read-only panels
 *    render their vendor type's slice of it (highlighting the selected quote) instead of just the
 *    single saved selection.
 */
export interface SEQuoteCandidatesContextValue {
  reportCandidates: (fieldKey: string, quotes: QuoteType[]) => void;
  savedCandidates?: QuoteType[];
}

export const SEQuoteCandidatesContext = React.createContext<SEQuoteCandidatesContextValue>({
  reportCandidates: () => undefined,
  savedCandidates: undefined,
});
